/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsProductsCarousel = {
    init: function ($section) {
      
      // Add settings from schema to current object
      window.PXUTheme.jsProductsCarousel = $.extend(this, window.PXUTheme.getSectionData($section));
      
      this.element = $section[0];
      this.carouselEl = $section[0].querySelector(".Section--products_carousel--carousel")
      this.carousel = new Flickity( this.carouselEl, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        wrapAround: true,
        arrowShape: 'M11.7672 39.8824L100.32 39.8824L100.32 46.1977L11.7672 46.1977C15.583 49.7501 25.4514 59.7493 33.7409 68.696C38.8725 73.9588 44.2672 79.6163 50.0567 85.8L40.9777 85.8C31.504 75.9324 11.6356 53.9603 0.319832 43.04C11.504 31.8567 31.3725 10.1477 40.9777 0.28005L50.0567 0.280051L33.7409 17.2525C25.1883 26.1992 15.583 36.0669 11.7672 39.8824Z'
      });

      // Resize flickity when the slider is settled
      $(this.carousel).on( 'settle.flickity', function() {
        $slideshowCustomEl.flickity('resize');
      });

      this.delegateElement = new domDelegate.Delegate($section[0]);
    },
    showThemeEditorState() {
      
    },
    hideThemeEditorState() {
      
    },
    unload: function ($section) {
      
    }
  }
  
  /******/ })()
  ;